// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__eJlyN","title":"styles_title__yCn0a","content":"styles_content__u4RtE","row":"styles_row__SFVkG","limitName":"styles_limitName__FykNZ"};